import { Row, RowList } from 'smoothie';

interface EmptyTransactionsProps {
    isPaymentTransactionTable?: boolean;
}

export const EmptyTransactions = ({
    isPaymentTransactionTable = false,
}: EmptyTransactionsProps) => {
    const title = isPaymentTransactionTable
        ? 'Payment history'
        : 'Transactions';

    return (
        <RowList
            rowHeaderProps={{
                title,
            }}
        >
            <Row title="You'll see pending and posted transactions here once you have some." />
        </RowList>
    );
};
